<!-- Side menu containing filters and other options -->
<template>
  <div class="menu">
    <!-- Top section (settings, counts) -->
    <div class="top">
      <div class="filter">
        <div class="row">
          <!-- Tooltip toggle -->
          <!-- <div
            v-if="$mq === 'lg'"
            class="col-xs filter-title logout"
            v-tooltip.left="tooltips.tooltip"
          >
            <input type="checkbox" id="tooltips" v-model="$store.state.settings.showTooltips" />
            <label for="tooltips" class="checkbox-label">Tooltips</label>
          </div>-->
          <!-- FAQ -->
          <div class="col-xs filter-title logout">
            <a
              href="https://theindexproject.org/stories/big-picture-faq"
              target="_blank"
              style="color: var(--white); text-decoration: none"
              >FAQ</a
            >
          </div>
          <!-- Logout -->
          <div class="col-xs end-xs row middle-xs logout" @click="logout()">
            <icon icon="arrow-left" style="margin-right: 0.3vw" />Logout
          </div>
        </div>
      </div>

      <!-- Counts -->
      <div class="filter">
        <div class="row">
          <div class="filter-title" v-tooltip.left="tooltips.totalCount">
            Total designs:
          </div>
          <div class="col-xs end-xs">
            <span>{{ totalCount }}</span>
          </div>
        </div>
        <div class="row">
          <div class="filter-title" v-tooltip.left="tooltips.filteredCount">
            Filtered designs:
          </div>
          <div class="col-xs end-xs">
            <span>{{ filteredCount }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Middle section (filters) -->
    <div class="middle">
      <simplebar class="filter-scrollbar" data-simplebar-click-on-track="false">
        <!-- Presets -->
        <div class="filter middle-xs">
          <div v-tooltip.top="tooltips.presets">
            <v-select
              taggable
              class="v-select presets"
              v-model="preset"
              @input="setPreset"
              @search:blur="deleteConfirm = false"
              placeholder="Presets"
              :options="Object.keys($store.state.presets)"
            >
              <template #no-options>
                <span class="presets-empty"
                  >Type and press Enter to create a new preset</span
                >
              </template>
            </v-select>
          </div>

          <div class="row preset-buttons">
            <div
              class="col-xs-6"
              :class="[preset == null ? 'disabled' : 'active']"
              v-tooltip.top="tooltips.presetSave"
              @click="savePreset(preset)"
            >
              <icon icon="save" size="sm" />
              {{ saveConfirm ? "Preset saved!" : "Save" }}
            </div>
            <div
              class="col-xs-6"
              :class="[preset == null ? 'disabled' : 'active']"
              v-tooltip.top="tooltips.presetDelete"
              @click="deletePreset(preset)"
              @mouseleave="deleteConfirm = false"
            >
              <icon icon="trash" size="sm" />
              {{ deleteConfirm ? "Are you sure?" : "Delete" }}
            </div>
          </div>
        </div>

        <!-- Display -->
        <!-- TODO: v-tooltip.left="tooltips.display", messes with lower widths -->
        <div class="filter">
          <div
            class="filter-title pointer"
            @click="opened.display = !opened.display"
          >
            <icon v-if="!opened.display" icon="arrow-right-short" size="sm" />
            <icon v-else icon="arrow-down-short" size="sm" />
            {{ "\xa0" }}Display
          </div>
          <transition name="slider-display">
            <div v-show="opened.display">
              <div
                v-for="filter in displayFilters"
                :key="filter"
                class="checkbox-custom"
              >
                <input
                  type="checkbox"
                  :id="filter"
                  :value="filter"
                  v-model="$store.state.filters.enabled"
                />
                <label
                  :for="filter"
                  class="checkbox-label"
                  v-tooltip.top="tooltips[filter]"
                  >{{ filter }}</label
                >
              </div>
            </div>
          </transition>
        </div>

        <!-- Extra filters -->
        <!-- TODO: v-tooltip.left="tooltips.extra", messes with lower widths -->
        <div class="filter">
          <div
            class="filter-title pointer"
            @click="opened.extra = !opened.extra"
          >
            <icon v-if="!opened.extra" icon="arrow-right-short" size="sm" />
            <icon v-else icon="arrow-down-short" size="sm" />
            {{ "\xa0" }}Extra
          </div>
          <transition name="slider-extra">
            <div v-show="opened.extra">
              <div
                v-for="filter in Object.keys(extraDisplay)"
                :key="filter"
                class="checkbox-custom"
              >
                <input
                  type="checkbox"
                  :id="filter"
                  :value="filter"
                  v-model="$store.state.filters.extra"
                />
                <label
                  :for="filter"
                  class="checkbox-label-extra"
                  v-tooltip.top="tooltips[filter]"
                  >{{ extraDisplay[filter] }}</label
                >
              </div>
            </div>
          </transition>
        </div>

        <!-- Filter line -->
        <hr style="border-top: 1px solid var(--white); opacity: 0.5" />
        <div class="row" v-if="filteredCount != totalCount">
          <div class="active-filters-text">Active Filters</div>
          <div
            class="clear-all-text col-xs end-xs"
            @click="clearFilters()"
            v-tooltip="tooltips.clear"
          >
            ✕ Clear All
          </div>
        </div>

        <!-- Active filters -->
        <div
          v-for="filter in filters.filter(
            (f) => $store.state.filters[f].length != 0
          )"
          :key="filter"
          class="filter row"
        >
          <div class="col-xs filter-title">{{ filter }}:</div>
          <div
            v-if="filter != 'extra'"
            class="filter-mode col-xs end-xs"
            @click="switchFilterMode(filter)"
            v-tooltip="tooltips.mode"
          >
            {{ modeDisplay[$store.state.filters.mode[filter]] }}
          </div>
          <div
            class="sub-filter col-xs-12"
            v-for="(subfilter, i) in $store.state.filters[filter]"
            :key="i"
            @click="removeFilter(filter, subfilter)"
          >
            ✕
            {{
              filter == "keyword"
                ? $store.state.filters.keywordName[i]
                : filter == "extra"
                ? extraDisplay[subfilter]
                : filter == "year" || filter == "month" || filter == "search"
                ? subfilter
                : subfilters[filter][subfilter - 1]
            }}
          </div>
        </div>
      </simplebar>
    </div>

    <!-- Bottom section (search, close) -->
    <div class="row bottom bottom-xs">
      <div class="col-xs-3">
        <button
          class="filter-close-button row middle-xs"
          @click="toggleFunction"
        >
          <icon icon="cross" size="lg" class="col-xs" />
        </button>
      </div>
      <div class="search-wrapper col-xs">
        <input
          class="search"
          type="search"
          v-model="search"
          @keydown.enter="triggerSearch"
        />
      </div>
    </div>
  </div>
</template>

<script>
import VTooltip from "v-tooltip";
import _ from "lodash";

export default {
  props: ["totalCount", "filteredCount", "toggleFunction"],
  data() {
    return {
      preset: null,
      search: "",
      deleteConfirm: false,
      saveConfirm: false,
      tooltips: {
        tooltip: "Show tooltips like this.",
        totalCount: "The total amount of nominees in the database.",
        filteredCount: "The amount of nominees after filtering.",
        presets:
          "Presets allow you to save combinations of filters that you use often.",
        presetSave: "Save the currently selected preset.",
        presetDelete: "Delete the currently selected preset.",
        display:
          "Choose which charts and tables get displayed. The less you choose, the better the performance.",
        month: "The month when the design was nominated.",
        category: "The category of the design.",
        goal: "The SDG goals of the design. Sometimes referred to as 'challenges'.",
        continent: "The continent where the design came from.",
        year: "The award year when the design was nominated.",
        region: "The regions where the design is meant to be used.",
        country: "The design's country of origin.",
        keyword: "The keywords used to describe the design.",
        extra: "Additional filters that you won't find in the charts.",
        index: "Designs nominated by users from The Index Project.",
        nominee: "Designs that have been nominated (no finalists or winners).",
        finalist: "Designs chosen to be finalists (no winners).",
        winner: "Designs that have won an Index Award.",
        clear: "Clears all currently selected filters.",
        mode: "Filtering mode. 'any' retrieves the designs with any of these attributes, 'all' retrieves designs with all attributes, 'none' retrieves designs with none of these attributes.",
      },
      opened: {
        display: false,
        extra: false,
        competitions: false,
      },
      filters: [
        "extra",
        "month",
        "category",
        "goal",
        "continent",
        "year",
        "region",
        "country",
        "keyword",
        "search",
      ],
      displayFilters: [
        "month",
        "category",
        "goal",
        "continent",
        "year",
        "region",
        "country",
        "keyword",
      ],
      subfilters: {
        category: ["Body", "Home", "Work", "Play & Learning", "Community"],
        goal: [
          "No Poverty",
          "Zero Hunger",
          "Good Health & Well-being",
          "Quality Education",
          "Gender Equality",
          "Clean Water & Sanitation",
          "Affordable & Clean Energy",
          "Decent Work & Economic Growth",
          "Industry, Innovation & Infrastructure",
          "Reduced Inequality",
          "Sustainable Cities & Communities",
          "Responsible Consumption & Production",
          "Climate Action",
          "Life Below Water",
          "Life On land",
          "Peace, Justice & Strong Institutions",
          "Partnerships for the Goals",
          "Navigate Post-Factual Society",
          "Balance Human & Artificial Intelligence",
          "Trust, Tolerance & Empathy",
          "Innovative Financial System",
          "Refugees and Migrants",
        ],
        country: [
          "Burundi",
          "Comoros",
          "Djibouti",
          "Eritrea",
          "Ethiopia",
          "Kenya",
          "Madagascar",
          "Malawi",
          "Mauritius",
          "Mozambique",
          "Reunion",
          "Rwanda",
          "Seychelles",
          "Somalia",
          "Uganda",
          "United Rep. of Tanzania",
          "Zambia",
          "Zimbabwe",
          "Angola",
          "Cameroon",
          "Central African Republic",
          "Chad",
          "Congo",
          "Dem. Republic of the Congo",
          "Equatorial Guinea",
          "Gabon",
          "Sao Tome and Principe",
          "Algeria",
          "Egypt",
          "Libyan Arab Jamahiriya",
          "Morocco",
          "Sudan",
          "Tunisia",
          "Western Sahara",
          "Botswana",
          "Lesotho",
          "Namibia",
          "South Africa",
          "Swaziland",
          "Benin",
          "Burkina Faso",
          "Cape Verde",
          "Cote d'Ivoire",
          "Gambia",
          "Ghana",
          "Guinea",
          "Guinea-Bissau",
          "Liberia",
          "Mali",
          "Mauritania",
          "Niger",
          "Nigeria",
          "Saint Helena",
          "Senegal",
          "Sierra Leone",
          "Togo",
          "China",
          "Dem. People's Rep. of Korea",
          "Hong Kong SAR",
          "Japan",
          "Macao, China",
          "Mongolia",
          "Republic of Korea",
          "Afghanistan",
          "Bangladesh",
          "Bhutan",
          "India",
          "Iran (Islamic Republic of)",
          "Kazakhstan",
          "Kyrgyzstan",
          "Maldives",
          "Nepal",
          "Pakistan",
          "Sri Lanka",
          "Tajikistan",
          "Turkmenistan",
          "Uzbekistan",
          "Brunei Darussalam",
          "Cambodia",
          "Indonesia",
          "Lao People's Dem. Republic",
          "Malaysia",
          "Myanmar",
          "Philippines",
          "Singapore",
          "Thailand",
          "Timor-Leste",
          "Viet Nam",
          "Armenia",
          "Azerbaijan",
          "Bahrain",
          "Cyprus",
          "Georgia",
          "Iraq",
          "Israel",
          "Jordan",
          "Kuwait",
          "Lebanon",
          "Oman",
          "Qatar",
          "Saudi Arabia",
          "Syrian Arab Republic",
          "Turkey",
          "United Arab Emirates",
          "Yemen",
          "Belarus",
          "Bulgaria",
          "Czech Republic",
          "Hungary",
          "Poland",
          "Republic of Moldova",
          "Romania",
          "Russian Federation",
          "Slovakia",
          "Ukraine",
          "Channel Islands",
          "Denmark",
          "Estonia",
          "Faeroe Islands",
          "Finland",
          "Iceland",
          "Ireland",
          "Isle of Man",
          "Latvia",
          "Lithuania",
          "Norway",
          "Sweden",
          "United Kingdom",
          "Albania",
          "Andorra",
          "Bosnia and Herzegovina",
          "Croatia",
          "Gibraltar",
          "Greece",
          "Holy See",
          "Italy",
          "Malta",
          "Portugal",
          "San Marino",
          "Slovenia",
          "Spain",
          "Republic of Macedonia",
          "Yugoslavia",
          "Austria",
          "Belgium",
          "France",
          "Germany",
          "Liechtenstein",
          "Luxembourg",
          "Monaco",
          "Netherlands",
          "Switzerland",
          "Anguilla",
          "Antigua and Barbuda",
          "Aruba",
          "Bahamas",
          "Barbados",
          "British Virgin Islands",
          "Cayman Islands",
          "Cuba",
          "Dominica",
          "Dominican Republic",
          "Grenada",
          "Guadeloupe",
          "Haiti",
          "Jamaica",
          "Martinique",
          "Montserrat",
          "Netherlands Antilles",
          "Puerto Rico",
          "Saint Kitts and Nevis",
          "Saint Lucia",
          "Saint Vincent and Grenadines.",
          "Trinidad and Tobago",
          "Turks and Caicos Islands",
          "United States Virgin Islands.",
          "Belize",
          "Costa Rica",
          "El Salvador",
          "Guatemala",
          "Honduras",
          "Mexico",
          "Nicaragua",
          "Panama",
          "Argentina",
          "Bolivia",
          "Brazil",
          "Chile",
          "Colombia",
          "Ecuador",
          "Falkland Islands (Islas Malvinas)",
          "French Guiana",
          "Guyana",
          "Paraguay",
          "Peru",
          "Suriname",
          "Uruguay",
          "Venezuela",
          "Bermuda",
          "Canada",
          "Greenland",
          "Saint Pierre and Miquelon",
          "United States of America",
          "Australia",
          "New Zealand",
          "Norfolk Island",
          "Fiji",
          "New Caledonia",
          "Papua New Guinea",
          "Solomon Islands",
          "Vanuatu",
          "Fed. States of Micronesia",
          "Guam",
          "Johnston Island",
          "Kiribati",
          "Marshall Islands",
          "Nauru",
          "Northern Mariana Islands",
          "Palau",
          "American Samoa",
          "Cook Islands",
          "French Polynesia",
          "Niue",
          "Pitcairn",
          "Samoa",
          "Tokelau",
          "Tonga",
          "Tuvalu",
          "Wallis and Futuna Islands",
          "Taiwan",
          "Montenegro",
          "Serbia",
        ],
        continent: [
          "Africa",
          "Asia",
          "Europe",
          "North America",
          "Oceania",
          "South America",
        ],
        region: [
          "Africa",
          "Asia",
          "Europe",
          "North America",
          "Oceania",
          "South America",
          "Central America",
        ],
      },
      // TODO change to a predicate function for each that gets added to filter() in Overview
      extraDisplay: {
        // index: "Spotted by Index",
        finalist: "Finalists",
        winner: "Winners",
        "comp-0": "Index Award",
        "comp-1": "Diseño Responde 2021",
        "comp-2": "Diseño Responde 2023",
      },
      modeDisplay: {
        or: "any",
        and: "all",
        nor: "none",
      },
    };
  },
  computed: {
    settings() {
      return [this.$store.state.settings.showTooltips];
    },
  },
  watch: {
    settings() {
      // Stores settings whenever the fields are changed
      this.$store.dispatch("storeSettings");
      VTooltip.enabled =
        this.$mq === "lg" && this.$store.state.settings.showTooltips;
    },
  },
  methods: {
    // Logs out by removing user token
    logout() {
      this.$store.dispatch("logout");
      this.$router.push("/login");
    },
    // Pushes the search keyword to filters
    triggerSearch() {
      this.$store.state.filters.search.push(this.search);
      this.search = "";
    },
    // Sets preset into the state
    setPreset(preset) {
      // selected existing preset - copy from preset to filter
      if (this.$store.state.presets.hasOwnProperty(preset)) {
        this.$store.state.filters = JSON.parse(
          JSON.stringify(this.$store.state.presets[preset])
        );
      }
      // selected new preset - create new preset, copy from filter to preset
      else if (preset != null) {
        this.$store.state.presets[preset] = JSON.parse(
          JSON.stringify(this.$store.state.filters)
        );
        // sends preset to API
        this.$store.dispatch("savePreset", {
          filters: this.$store.state.presets[preset],
          name: preset,
        });
      }
      // deselected (preset = null)
      else {
        this.$store.state.filters = JSON.parse(
          JSON.stringify(this.$store.state.defaultFilters)
        );
      }
    },
    // Saves preset and sends it to API
    savePreset(preset) {
      // checks if preset has been selected
      if (preset == null) return;
      // saves the current filters to the selected preset
      if (!this.saveConfirm) {
        this.$store.state.presets[preset] = JSON.parse(
          JSON.stringify(this.$store.state.filters)
        );
        // sends preset to API
        this.$store.dispatch("savePreset", {
          filters: this.$store.state.presets[preset],
          name: preset,
        });
        // change save text
        this.saveConfirm = true;
        setTimeout(() => {
          this.saveConfirm = false;
        }, 1500);
      }
    },
    // Deletes a preset locally and from the DB
    deletePreset(preset) {
      if (preset == null) return;
      if (!this.deleteConfirm) {
        this.deleteConfirm = true;
      } else {
        console.log("deleting: " + preset);
        this.$store.dispatch("deletePreset", {
          presetId: this.$store.state.presets[preset].id,
        });
        delete this.$store.state.presets[preset];
        this.preset = null;
        this.deleteConfirm = false;
        this.$store.state.filters = JSON.parse(
          JSON.stringify(this.$store.state.defaultFilters)
        );
      }
    },
    // Removes filter from the array
    removeFilter(type, id) {
      let index = this.$store.state.filters[type].indexOf(id);
      if (index > -1) this.$store.state.filters[type].splice(index, 1);
      if (index > -1 && type == "keyword")
        this.$store.state.filters["keywordName"].splice(index, 1);
    },
    // Switches filter mode (or/and/nor), some filters don't have 'and'
    switchFilterMode(filter) {
      let mode = this.$store.state.filters.mode[filter];
      if (
        filter == "goal" ||
        filter == "region" ||
        filter == "keyword" ||
        filter == "search"
      ) {
        if (mode == "or") this.$store.state.filters.mode[filter] = "and";
        else if (mode == "and") this.$store.state.filters.mode[filter] = "nor";
        else if (mode == "nor") this.$store.state.filters.mode[filter] = "or";
      } else {
        if (mode == "or") this.$store.state.filters.mode[filter] = "nor";
        else if (mode == "nor") this.$store.state.filters.mode[filter] = "or";
      }
    },
    // Clears all selected filters
    clearFilters() {
      let enabled = this.$store.state.filters.enabled;
      this.$store.state.filters = JSON.parse(
        JSON.stringify(this.$store.state.defaultFilters)
      );
      this.$store.state.filters.enabled = [].concat(enabled);
    },
    // Triggers the tooltips to toggle
    triggerTooltips() {
      this.$store.state.settings.showTooltips =
        !this.$store.state.settings.showTooltips;
      this.$store.state.settings.showTooltips =
        !this.$store.state.settings.showTooltips;
    },
  },
  mounted() {
    this.triggerTooltips();
  },
};
</script>

<style scoped>
@media only screen and (max-width: 767px) {
  .menu {
    left: 3% !important;
  }
  input[type="checkbox"] {
    padding: 1.2vw !important;
  }
  .top {
    height: 28vw !important;
    padding: 4vw !important;
  }
  .middle {
    /* subtract top and bottom heights */
    height: calc(100vh - 28vw - 18vw) !important;
    padding: 4vw !important;
  }
  .filter-scrollbar {
    /* subtract top and bottom heights and middle padding */
    height: calc(100vh - 28vw - 18vw - 4vw) !important;
  }
  .bottom {
    height: 18vw !important;
    padding: 4vw !important;
  }
  .filter {
    margin-bottom: 4vw !important;
  }
  .presets-save {
    margin-left: 2vw !important;
  }
  .search-wrapper {
    margin-bottom: 2vw !important;
    height: 10vw !important;
  }
  .search {
    width: 97% !important;
    height: 10vw !important;
    background-size: 5vw !important;
  }
}
.menu {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 83.333333%;
  background: var(--red);
  color: var(--white);
  font-size: var(--vw14px);
  z-index: 11;
}
.top {
  height: 8vw;
  padding: 1vw;
  background: var(--black);
}
.middle {
  /* subtract top and bottom heights */
  height: calc(100vh - 8vw - 5vw);
  padding: 1vw;
  overflow-x: hidden;
}
.filter-scrollbar {
  /* subtract top and bottom heights and middle padding */
  height: calc(100vh - 8vw - 5vw - 2vw);
}
.bottom {
  height: 5vw;
  padding: 1vw;
}
.filter {
  margin-bottom: 1.5vw;
}
.sub-filter {
  cursor: pointer;
  user-select: none;
}
.filter-title {
  text-transform: capitalize;
  font-family: IndexText-Bold;
  user-select: none;
}
.filter-mode {
  cursor: pointer;
  user-select: none;
  opacity: 0.5 !important;
}
.pointer {
  cursor: pointer;
}

.v-select {
  /* width: 85%; */
  width: 100%;
  border: 1px solid var(--grey100);
}
.v-select >>> .vs__search::placeholder,
.v-select >>> .vs__dropdown-toggle,
.v-select >>> .vs__dropdown-menu {
  border: 0;
  border-radius: 0;
  font-family: "IndexText-Regular", "Helvetica";
}
.v-select.presets >>> .vs__selected {
  background-color: transparent;
  color: var(--white);
}
.v-select >>> .vs__clear,
.v-select >>> .vs__open-indicator {
  fill: var(--white);
}
.preset-buttons {
  margin-top: 5px;
}
.preset-buttons .active {
  cursor: pointer;
  user-select: none;
}
.preset-buttons .active:hover {
  opacity: 0.8;
}
.preset-buttons .disabled {
  user-select: none;
  opacity: 0.5;
}
.presets-empty {
  text-align: center;
  color: var(--grey600);
}

.active-filters-text {
  opacity: 0.5;
  margin-bottom: 1vw;
}
.clear-all-text {
  /* opacity: 0.5; */
  margin-bottom: 1vw;
  cursor: pointer;
}

.search-wrapper {
  border-bottom: 1px solid var(--grey200);
  height: 2.5vw;
  width: 19vw;
}
.search {
  font-size: var(--vw17px);
  margin: 0.1vw 0.5vw;
  color: var(--white);
  width: calc(100% - 1.2vw);
  background-image: url("../assets/icons/search_w.svg");
  background-repeat: no-repeat;
  background-size: 1vw;
  background-position: 100% 50%;
  height: 2vw;
  border-width: 0;
  background-color: transparent;
  font-family: "IndexText-Regular", "Helvetica";
}
input[type="checkbox"] {
  -webkit-appearance: none;
  background-color: transparent;
  border: 1px solid var(--white);
  padding: 0.3vw;
  display: inline-block;
  position: relative;
  margin: 0 0.6vw -0.05vw 0;
  cursor: pointer;
}
input[type="checkbox"]:checked {
  background-color: var(--white);
}
.checkbox-label {
  text-transform: capitalize;
  user-select: none;
  cursor: pointer;
}
.checkbox-label-extra {
  user-select: none;
  cursor: pointer;
}
label {
  margin: 0;
}
@media only screen and (max-width: 767px) {
  .filter-close-button {
    height: 10vw !important;
    width: 10vw !important;
    font-size: var(--vw38px) !important;
    margin: 0 0 2vw !important;
  }
}
.filter-close-button {
  background-color: transparent;
  border: 1px solid var(--white);
  height: 2.5vw;
  width: 2.5vw;
  margin: 0 0 0;
  padding: 0;
  color: var(--white);
  font-size: var(--vw20px);
  cursor: pointer;
}
.logout {
  cursor: pointer;
  opacity: 0.5;
}

@media only screen and (max-width: 767px) {
  .slider-display-enter-active,
  .slider-display-leave-active {
    max-height: 45vw;
  }
  .slider-extra-enter-active,
  .slider-extra-leave-active {
    max-height: 25vw;
  }
}
@media only screen and (min-width: 768px) {
  .slider-display-enter-active,
  .slider-display-leave-active {
    max-height: 12vw;
  }
  .slider-extra-enter-active,
  .slider-extra-leave-active {
    max-height: 8vw;
  }
}
.slider-display-enter-active,
.slider-display-leave-active,
.slider-extra-enter-active,
.slider-extra-leave-active {
  transition: all 0.5s ease;
  overflow: hidden;
}
.slider-display-enter,
.slider-display-leave-to,
.slider-extra-enter,
.slider-extra-leave-to {
  max-height: 0;
  padding: 0;
  overflow: hidden;
}
</style>